import AxiosAPI from '../../utils/AxiosAPI';

// load all support tickets
export const ApiLoadSupportTickets = (params) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/support-ticket`, {
                q: params.q,
                department: params.department,
                status: params.status,
                orderby: params['order-by'] || 'id',
                sort: params.sort || 'desc',
                page: params.page || 1,
                cpp: params.cpp || 12
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// load user subscriptions and services
export const ApiLoadOptionalData = (userId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/support-ticket/${userId}/user-subscriptions-services`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// load support ticket info by id
export const ApiLoadSupportTicketInfo = (id) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/support-ticket/${id}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Send support ticket message
export const ApiSendSupportMessage = (id, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/support-ticket/${id}/new-message`)
            .post({ ...formData })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Upload support ticket attachment
export const ApiUploadSupportTicketAttachment = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/support-ticket/upload-attachment`)
            .put(formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName || '');
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Create support ticket
export const ApiIssueSupportTicket = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/support-ticket`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Update support ticket
export const ApiUpdateSupportTicket = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/support-ticket/${id}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Close support ticket
export const ApiCloseSupportTicket = (id, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/support-ticket/${id}/close`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// reopen support ticket
export const ApiReopenSupportTicket = (id) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/support-ticket/${id}/reopen`)
            .put()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
